import './polyfills';
import { render } from 'preact';
import { App } from './app';
import { reportUncaughtErrors } from './lib/clientErrors';

reportUncaughtErrors();

render(<App />, document.getElementById('app')!);
